import React, { useState } from "react";
import { useSIP } from "../../hooks/calls/useSIP";
import { useDispatch, useSelector } from "react-redux";
import DialPad from "./DialPad";
import toast from "react-hot-toast";
import { setSubModal } from "../../features/modal/ModalSlice";

const DialpadButton = () => {
  const modal = useSelector((state) => state?.modal?.modal);
  const userInfo = useSelector((state) => state.userInfo.user);
  const [dialNumber, setDialNumber] = useState(
    modal?.data || userInfo?.is_demo_account ? "6467511551" : ""
  );

  const { dialCall } = useSIP();
  const dispatch = useDispatch();

  const handleDial = () => {
    const trimmedDialNumber = dialNumber.trim();
    const allowedDemoNumbers = [
      "6467511551",
      "16467511551",
      "+16467511551",
      "987",
      "104",
      "128",
    ];

    if (userInfo?.is_demo_account) {
      if (allowedDemoNumbers.includes(trimmedDialNumber)) {
        dialCall(trimmedDialNumber);
        dispatch(setSubModal({ type: "ACTIVITY" }));
      } else {
        toast.error("Demo accounts can only dial 6467511551");
        setDialNumber("6467511551");
      }
    } else {
      dialCall(trimmedDialNumber);
    }
  };

  return (
    <>
      <div>
        <DialPad
          dialNumber={dialNumber}
          setDialNumber={setDialNumber}
          handleDial={handleDial}
        />
      </div>
    </>
  );
};

export default DialpadButton;
